import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito conocimientos previos?',
    a: 'No. El contenido está diseñado para que cualquier persona pueda comenzar desde cero.'
  }, {
    q: '¿Es un curso con clases en video?',
    a: 'No. Grecia Legendaria es una colección 100% digital compuesta por módulos ilustrados que puedes leer a tu ritmo.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Una vez realizada la compra recibirás acceso inmediato para descargar todo el contenido.'
  }, {
    q: '¿Desde qué dispositivos puedo leerlo?',
    a: 'Puedes acceder desde computadora, notebook, tablet o teléfono celular.'
  }, {
    q: '¿El acceso tiene vencimiento?',
    a: 'No. El acceso es permanente para que puedas volver al contenido siempre que quieras.'
  }, {
    q: '¿Puedo descargar los archivos?',
    a: 'Sí. Podrás descargarlos y conservarlos para leerlos cuando desees.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-dark-card/30" data-id="element-79">
      <div className="max-w-3xl mx-auto" data-id="element-80">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-heading font-bold text-center text-white mb-16" data-id="element-81">
          PREGUNTAS FRECUENTES
        </motion.h2>

        <div className="space-y-4" data-id="element-82">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-dark-border rounded-xl bg-dark overflow-hidden" data-id="element-83">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-84">
                <span className="font-bold text-white pr-8" data-id="element-85">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-86" />
              </button>

              <AnimatePresence data-id="element-87">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-88">
                    <div className="px-6 pb-6 text-gray-300 leading-relaxed border-t border-dark-border/50 pt-4" data-id="element-89">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}